import { IController, IComponentOptions } from "angular";

/**
 * @example <private-badge size="h-18"></private-badge>
 * @attr size "h-18" (to be extended, used as CSS selector)
 * @styling attribute selectors are used as well for sizing, e.g. private-badge[size="h-18"]
 */
export class PrivateBadgeCtrl implements IController {}
export const PrivateBadgeComponent: IComponentOptions = {
  templateUrl: require("./private-badge.jade"),
  controller: PrivateBadgeCtrl,
  bindings: {},
};
